














































































































































































































































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import DataTableV2 from '@/app/ui/components/DataTableV2/index.vue'
import {
  DataObject,
  HeaderObject,
  SortValueObject,
} from '@/app/ui/components/DataTableV2/type'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import PickupController, {
  DropdownValue,
} from '@/app/ui/controllers/PickupController'
import { Utils } from '@/app/infrastructures/misc'
import {
  PickupAssignIds,
  PickupNfdDetailShipment,
  PickupNfdShipperHashDetail,
} from '@/domain/entities/Pickup'
import IconProfile from '@/app/ui/assets/ics_f_profile.vue'
import IconPhoneBlack from '@/app/ui/assets/ics_f_phone.vue'
import IconLocationPin from '@/app/ui/assets/ics_f_location_pin.vue'
import IconCourier from '@/app/ui/assets/icon_motorcycle_front.vue'
import IconCancelTask from '@/app/ui/assets/icon_cancel_task.vue'
import IconWhatsApp from '@/app/ui/assets/ics_f_whatsapp.vue'
import ScheduleAssigneCourier from '@/app/ui/views/Pickup/components/ScheduleAssigneCourier/index.vue'
import ModalSuccess from '@/app/ui/views/Pickup/components/Modals/ModalSuccess.vue'
import Skeleton from '@/app/ui/components/Skeleton/index.vue'
import PriorityIcon from '@/app/ui/assets/ics_f_priority-fast.vue'
import { ManageCourierDetail } from '@/domain/entities/ManageCourier'
import ManageCourierController from '@/app/ui/controllers/ManageCourierController'

@Component({
  components: {
    LoadingOverlay,
    Button,
    DataTableV2,
    PaginationNav,
    DropdownSelect,
    IconProfile,
    IconPhoneBlack,
    IconLocationPin,
    IconCourier,
    IconCancelTask,
    IconWhatsApp,
    ScheduleAssigneCourier,
    ModalSuccess,
    Skeleton,
    PriorityIcon,
  },
})
class PickupCRRNFDManualAssignByShipper extends Vue {
  controller = PickupController
  mcController = ManageCourierController

  tableSlotNames = [
    '',
    'orderid',
    'producttype',
    'totalkoli',
    'crrnfddate',
    'crrnfddur',
    'nfdstatus',
  ]

  parameters = {
    page: 1,
    perPage: 10,
    sort: {
      name: '',
      direction: '' as string,
    },
  }

  tableData: DataObject[][] = []

  form: {
    courier: DropdownValue | undefined
    manualAssignDate: Date | undefined
    manualAssignHour: number
    manualAssignMinute: number
  } = {
    courier: undefined,
    manualAssignDate: undefined,
    manualAssignHour: 0,
    manualAssignMinute: 0,
  }

  isScheduleManualAssign = false
  assignSuccessVisible = false
  assignSuccessDescription = ''
  assignSubmitting = false
  isAtBottom = false;
  observer: IntersectionObserver | null = null;
  isAllData = false
  courierPhone = '';

  get shipperHash(): string {
    return String(this.$route.params.shipperHash || '').trim()
  }

  get detail(): PickupNfdShipperHashDetail | null {
    return this.controller.pickupNfdShipperHashDetail
  }

  get isPageLoading(): boolean {
    return this.controller.isLoadingPickupNfdShipperDetail && !this.detail
  }

  get isTableLoading(): boolean {
    return this.controller.isLoadingPickupNfdShipperDetail && Boolean(this.detail)
  }

  get courierOptions(): DropdownValue[] {
    return this.controller.courierData
  }

  get isCourierLoading(): boolean {
    return this.controller.isCourierLoading
  }

  get clientLine(): string {
    const d = this.detail
    if (!d) return ''
    if (d.clientId != null && String(d.clientId) !== '') {
      return `(${d.clientId} - ${d.clientName || '-'})`
    }
    return ''
  }

  get lastCourierLine(): string {
    const c = this.detail?.lastCourier
    if (!c || (!c.courierId && !c.courierName)) return '—'
    const phone = this.formatPhoneDisplay(c.courierPhone)
    const phonePart = phone ? ` ${phone}` : ''
    const courierType = c.courierType ? ` (${c.courierType})` : ''
    return `[${c.courierId || '—'}] ${c.courierName || ''}${courierType}`.trim()
  }

  get lastCourierLineAgent(): string {
    const c = this.detail?.lastCourier
    if (!c || (!c.agentCode && !c.agentName)) {
      return '—'
    }

    const agentName = c.agentName ? ` ${c.agentName}` : ''
    const agentCode = c.agentCode ? ` [${c.agentCode}]` : ''
    return `${agentName}${agentCode}`.trim()
  }

  get totalItems(): number {
    return this.detail?.pagination?.totalItem ?? 0
  }

  get scheduleManualAssignValue(): Date | null {
    if (!this.form.manualAssignDate) return null
    const d = new Date(this.form.manualAssignDate.getTime())
    d.setHours(this.form.manualAssignHour, this.form.manualAssignMinute, 0, 0)
    return d
  }

  get disableSubmit(): boolean {
    return (
      this.assignSubmitting ||
      !this.form.courier ||
      (this.isScheduleManualAssign && !this.form.manualAssignDate)
    )
  }

  get lastCourierPhone(): string {
    return this.detail?.lastCourier?.courierPhone || ""
  }

  headers: HeaderObject[] = []

  created(): void {
    this.initHeaders()
    void this.bootstrap()
  }

  mounted(): void {
    this.controller.getCourierList({
      perPage: 30,
      courierStatus: 'ACTIVE',
      driverType: 'KVP%3BPOS'
    })

    const options = { root: null, threshold: 1.0 };
    this.observer = new IntersectionObserver(([entry]) => {
      this.isAtBottom = entry.isIntersecting;
    }, options);

    const bottomLimit = this.$refs.bottomLimit as Element;
    if (bottomLimit) this.observer.observe(bottomLimit);
  }

  beforeUnmount() {
    if (this.observer) this.observer.disconnect();
  }

  beforeDestroy(): void {
    this.controller.clearPickupNfdShipperHashDetail()
  }

  @Watch('shipperHash')
  onShipperHashChange(): void {
    void this.bootstrap()
  }

  @Watch('detail', { deep: true })
  onDetailChange(): void {
    this.rebuildTable()
  }

  private initHeaders(): void {
    this.headers = [
      this.headerCellMapper('No.', '56px'),
      this.headerCellMapper('Order ID', '160px'),
      this.headerCellMapper('Jenis Paket', '140px'),
      this.headerCellMapper('Total Koli', '100px'),
      this.headerCellMapper('Tanggal CRRNFD', '176px', 'crrnfd_at', '16px'),
      this.headerCellMapper('Durasi CRRNFD', '160px', 'crrnfd_duration_minute', '12px'),
      this.headerCellMapper('NFD status', '140px'),
    ]
  }

  private headerCellMapper(
    title: string | number,
    colWidth: string,
    sortName?: string,
    sortWidth?: string
  ): HeaderObject {
    return {
      title: <string>title,
      customStyle: {
        minWidth: colWidth,
        maxWidth: colWidth,
      },
      withSort: Boolean(sortName),
      sortName: sortName,
      sortStyle: sortWidth ? { marginLeft: sortWidth } : {},
    }
  }

  private tableCellMapper(value: unknown, colWidth: string): DataObject {
    const customStyle = {
      maxWidth: colWidth,
      minWidth: colWidth,
    }
    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      const o = value as DataObject
      return {
        ...o,
        customStyle: { ...customStyle, ...o.customStyle },
      } as DataObject
    }
    return {
      value: value as DataObject['value'],
      customStyle,
    }
  }

  private async bootstrap(): Promise<void> {
    if (!this.shipperHash) {
      void this.$router.replace({ name: 'ListPickupCRRNFD' })
      return
    }
    this.parameters.page = 1
    await this.loadDetail(false)
  }

  private async loadDetail(resetPage: boolean): Promise<void> {
    if (!this.shipperHash) return
    if (resetPage) {
      this.parameters.page = 1
    }
    try {
      await this.controller.fetchPickupNfdByShipperHash({
        shipperHash: this.shipperHash,
        params: {
          page: this.parameters.page,
          perPage: this.parameters.perPage,
          sortField: this.parameters.sort.name,
          sortDirection: this.parameters.sort.direction,
          isShowDetail: this.isAllData,
        }
      })
    } catch (e) {
      const err = e as { status?: number; response?: { status?: number } }
      const st = err?.status ?? err?.response?.status
      if (st === 404) {
        void this.$router.replace({ name: 'ListPickupCRRNFD' })
      }
    }
  }

  private rebuildTable(): void {
    const d = this.detail
    if (!d) {
      this.tableData = []
      return
    }
    const rows = d.shipments || []
    const offset = (this.parameters.page - 1) * this.parameters.perPage
    this.tableData = rows.map((row: PickupNfdDetailShipment, index: number) => [
      this.tableCellMapper(String(offset + index + 1), '56px'),
      this.tableCellMapper({ shipmentId: row.shipmentId }, '160px'),
      this.tableCellMapper({ text: row.productType || '—' }, '140px'),
      this.tableCellMapper({ qty: row.totalQuantity }, '100px'),
      this.tableCellMapper(
        {
          date: Utils.formatDateWithIDLocale(row.crrnfdAt, 'DD MMM YYYY'),
          time: Utils.formatTimeZone(
            Utils.formatDateWithIDLocale(row.crrnfdAt, 'HH:mm Z')
          ),
        },
        '176px'
      ),
      this.tableCellMapper(
        { text: this.formatCrrnfdDurationMinutes(row.crrnfdDurationMinute) },
        '160px'
      ),
      this.tableCellMapper({ iteration: row.crrnfdIteration || 0 }, '140px'),
    ])
  }

  public formatNFDStatus(value: string | number): string {
    const status = parseInt(String(value), 10)
    if (status === 1) return 'one'
    if (status === 2) return 'two'
    if (status === 3) return 'three'
    if (status === 4) return 'four'
    if (status === 5) return 'five'
    return 'more'
  }

  public formatCrrnfdDurationMinutes(minutes: number): string {
    if (minutes == null || Number.isNaN(minutes)) {
      return '—'
    }
    let min = Math.max(0, Math.floor(minutes))
    const d = Math.floor(min / (24 * 60))
    min %= 24 * 60
    const h = Math.floor(min / 60)
    min %= 60
    const parts: string[] = []
    if (d) parts.push(`${d}d`)
    if (h) parts.push(`${h}h`)
    parts.push(`${min}m`)
    return parts.join(', ')
  }

  public onDataTableSort(val: SortValueObject): void {
    this.parameters.sort.name =  val.name || ""
    this.parameters.sort.direction = val.direction || ""
    void this.loadDetail(false)
  }

  public onPaginationPageInput(): void {
    void this.loadDetail(false)
  }

  public onPaginationPerPageChange(val: number): void {
    this.parameters.perPage = Number(val)
    void this.loadDetail(true)
  }

  public mapsHref(address: string): string {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      address || ''
    )}`
  }

  public waDigits(phone: string): string {
    return String(phone || '').replace(/\D/g, '')
  }

  public formatPhoneDisplay(phone: string): string {
    const raw = String(phone || '').trim()
    if (!raw) return ''
    const d = this.waDigits(raw)
    if (!d) return raw
    if (raw.startsWith('+')) return `+${d}`
    if (d.startsWith('62')) return `+${d}`
    if (d.startsWith('0')) return `+62${d.slice(1)}`
    return `+${d}`
  }

  public waSenderHref(phone: string): string {
    const d = this.waDigits(phone)
    const q = encodeURIComponent(
      'Hi Bapak/Ibu, kami ingin menghubungi terkait pickup Lion Parcel.'
    )
    return d ? `https://api.whatsapp.com/send?phone=${d}&text=${q}` : '#'
  }

  public courierSearch = Utils.debounce((search: string) => {
    const q = search === '' ? undefined : search
    this.controller.getCourierList({
      perPage: 30,
      q,
      courierStatus: 'ACTIVE',
      driverType: 'KVP%3BPOS'
    })
  }, 500)

  public onToggleScheduleManualAssign(active: boolean): void {
    this.isScheduleManualAssign = active
    if (!active) {
      this.form.manualAssignDate = undefined
    }
  }

  public onChangeManualAssignDate(value?: Date): void {
    if (value) {
      this.form.manualAssignDate = value
      this.form.manualAssignHour = value.getHours()
      this.form.manualAssignMinute = value.getMinutes()
    } else {
      this.form.manualAssignDate = undefined
    }
  }

  public async onToggleAllData(): Promise<void> {
    if (!this.isAllData) {
      if (this.form.courier?.value) {
        const resp = await this.controller.adminContactShow({
          field: 'courier_phone',
          resource: 'courier',
          resourceId: String(this.form.courier.value),
          source: 'pickup_nfd'
        })
        this.mcController.getCourierDetail({id: String(this.form.courier.value)});
        this.courierPhone = resp.value;
      }
    } else {
      this.courierPhone = '';
      this.mcController.manageCourierDetail.vehiclePlate = '';
    }

    this.isAllData = !this.isAllData
    void this.loadDetail(false)
  }

  public onBack(): void {
    this.$router.push('/pickup/CRRNFD-v2')
  }

  public getISOOffset(date: Date): string {
    const offsetMinutes = -date.getTimezoneOffset();
    const absOffset = Math.abs(offsetMinutes);

    const sign = offsetMinutes >= 0 ? "+" : "-";
    const hours = String(Math.floor(absOffset / 60)).padStart(2, '0');
    const minutes = String(absOffset % 60).padStart(2, '0');

    return `${sign}${hours}:${minutes}`;
  }

  public async onSubmitAssign(): Promise<void> {
    if (!this.form.courier || !this.shipperHash) return
    this.assignSubmitting = true
    try {
      const totalShipment = this.controller.pickupNfdList.data.find((g) => g.shipperHash === this.shipperHash)?.totalShipments || 0
      const body: {
        shipperHashes: PickupAssignIds[]
        courierId: number
        manualAssignDate?: string
        timeZone?: string
      } = {
        shipperHashes: [new PickupAssignIds(this.shipperHash, totalShipment)],
        courierId: Number(this.form.courier.value),
      }
      if (this.isScheduleManualAssign && this.form.manualAssignDate) {
        const dt = new Date(this.form.manualAssignDate.getTime())
        dt.setHours(
          this.form.manualAssignHour,
          this.form.manualAssignMinute,
          0,
          0
        )
        body.manualAssignDate = Utils.formatDateWithIDLocale(
          dt.toISOString(),
          'YYYY-MM-DD HH:mm:ss'
        )
        body.timeZone = this.getISOOffset(dt)
      }
      const results = await this.controller.manualAssignPickupBulkLiberta(body)
      const ok = results.filter(r => r.isSuccess)
      const fail = results.filter(r => !r.isSuccess)
      if (results.length === 0) {
        this.assignSuccessDescription = this.isScheduleManualAssign
          ? 'Jadwal assign telah diatur sesuai pilihan Anda.'
          : 'Kurir telah ditetapkan untuk pengirim ini.'
        this.assignSuccessVisible = true
      } else if (fail.length === 0) {
        this.assignSuccessDescription = this.isScheduleManualAssign
          ? 'Jadwal assign telah diatur sesuai pilihan Anda.'
          : 'Kurir telah ditetapkan untuk pengirim ini.'
        this.assignSuccessVisible = true
      } else if (ok.length === 0) {
        Vue.notify({
          title: 'Assign kurir',
          text:
            fail
              .map(f => `${f.shipperHash}: ${f.message || 'Gagal'}`)
              .join('; ') || 'Gagal menugaskan kurir.',
          type: 'error',
          duration: 8000,
        })
      } else {
        Vue.notify({
          title: 'Assign kurir',
          text: `Berhasil ${ok.length}, gagal ${fail.length}.`,
          type: 'warn',
          duration: 8000,
        })
      }
    } catch(error: any) {
      console.error(error, 'error disni')
    } finally {
      this.assignSubmitting = false
    }
  }

  public onCloseAssignSuccess(): void {
    this.assignSuccessVisible = false
    this.$router.push('/pickup/CRRNFD-v2')
  }


  @Watch('mcController.manageCourierDetail', {deep: true})
  onSetCourierLabel(courier: ManageCourierDetail) {
    if (this.form.courier?.label) {
      this.form.courier.label = `[${courier.courierId}] ${courier.fullName} (${courier.announcementCourierType}) ${this.courierPhone || '********'} • ${courier.partnerName}`
    }
  }
}
export default PickupCRRNFDManualAssignByShipper;
